import { useCallback, useMemo, useState } from "react";

export function useTodoSaveStatus() {
  const [statuses, setStatuses] = useState<{
    [key: string]: "saving" | "saved" | "error";
  }>({});

  const status = useMemo(() => {
    if (Object.values(statuses).some((val) => val === "error")) {
      return "error";
    }
    if (Object.values(statuses).some((val) => val === "saving")) {
      return "saving";
    }
    return "saved";
  }, [statuses]);

  const setStatus = useCallback(
    (key: string, status: "saving" | "saved" | "error") => {
      setStatuses((statuses) => ({ ...statuses, [key]: status }));
    },
    []
  );

  return [status, setStatus] as const;
}
